import { createContext, useContext } from "react";

interface ManageClientContextValue {
  /** Account id of the client the operator is managing (route `:clientId`). */
  clientId: string;
  /** True when the client's access has been removed — the record is read-only (DEV-1177). */
  isViewOnly: boolean;
}

const ManageClientContext = createContext<ManageClientContextValue | null>(null);

export const ManageClientProvider = ManageClientContext.Provider;

/**
 * Access the managed client's id inside a Manage-Client panel.
 * Pass this id to the reused client hooks (e.g. `useGetClientProfileQuery({ accountId })`).
 */
export const useManageClient = (): ManageClientContextValue => {
  const ctx = useContext(ManageClientContext);
  if (!ctx) {
    throw new Error("useManageClient must be used within <ManageClient>");
  }
  return ctx;
};
